export const Icons = {
	Search: '🔍',
	Close: '×',
	Add: '+',
	Sync: '↻',
	Synced: '✓',
	Checked:'✓',
	Local: '💾',
	Attachment: '📎',
	Comment: '💬',
	User: '👤',
	Menu: '⋮',
	Edit: '✎',
	EditDoc: '📝',
	Delete: '×',
	Save: '💾',
	Back: '←',
	Settings: '⚙️',
	Columns: '📱',
	List: '📲',
	Desktop: '🖥️',
	Expand: '▼',
	Collapse: '▲',
	ChevronDown: '▼',
	ChevronUp: '▲',
	ChevronRight: '▶',
	ChevronLeft: '◀',
	ArrowLeft: '←',
	ArrowRight: '→',
} as const;


